import { Component, OnInit } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FormControl } from '@angular/forms';

interface MultiOption {
  value: any;
  label: string;
  parent_id?: any;
  is_display: boolean;
}

@Component({
  selector: 'app-field-select-multi-option',
  template: `
    <select class="form-control" [formControl]="control">
      <option [ngValue]="null" disabled selected hidden>{{to.placeholder}}</option>
      <ng-container *ngFor="let opt of filteredOptions">
        <option *ngIf="opt.is_display || to.isPreview" [ngValue]="opt.value">
          {{ opt.label }} <span *ngIf="to.isPreview && !opt.is_display"> (一時)</span>
        </option>
      </ng-container>
    </select>
  `,
})
export class FormlyFieldSelectMultiOptionComponent extends FieldType<FieldTypeConfig> implements OnInit {
  filteredOptions: MultiOption[] = [];

  get control(): FormControl {
    return this.formControl as FormControl;
  }

  ngOnInit(): void {
    const parentKey = this.to?.parentKey;
  
    if (!parentKey) {
      this.filterOptions();
      return;
    }
  
    const parentControl = this.form.get(parentKey) as FormControl;
  
    if (parentControl) {
      this.filterOptions();
      parentControl.valueChanges.subscribe(() => this.filterOptions());
    } else {
      const subscription = this.form.valueChanges.subscribe(() => {
        const dynamicParentControl = this.form.get(parentKey) as FormControl;
  
        if (dynamicParentControl) {
          this.filterOptions();
          dynamicParentControl.valueChanges.subscribe(() => this.filterOptions());
          subscription.unsubscribe();
        }
      });
    }
  }

  private filterOptions(): void {
    const allOptions: MultiOption[] = (this.to?.options || []) as MultiOption[];
    const parentKey = this.to?.parentKey;

    if (!parentKey) {
      this.filteredOptions = allOptions;
      this.control.enable({ emitEvent: false });
      return;
    }

    const parentControl = this.form.get(parentKey) as FormControl;

    if (!parentControl) {
      return;
    }

    const applyFilter = (parentValue: any) => {
      const filtered = allOptions.filter(opt => opt.parent_id === parentValue && (opt.is_display || this.to.isPreview));
      this.filteredOptions = filtered;

      if (filtered.length === 0) {
        this.control.disable({ emitEvent: false });
      } else {
        this.control.enable({ emitEvent: false });
      }

      const currentValue = this.control.value;
      const matched = filtered.some(opt => opt.value === currentValue);
      if (!matched) {
        this.control.setValue(null);
      }
    };

    applyFilter(parentControl.value);
    parentControl.valueChanges.subscribe(applyFilter);
  }
}
